import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWebMatchPredictionApi, deleteWebMatchPredictionApi, toggleWebMatchPredictionPublishedStateApi } from './webMatchPredictionSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function WebMatchPrediction() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.eventSaga.webMatchPrediction);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '3rem',
            },
            {
                name: 'p1_class',
                selector: (row) => row.p1_class,
                sortable: true,
                width: '6rem',
            },
            {
                name: 'p2_class',
                selector: (row) => row.p2_class,
                sortable: true,
                width: '6rem',
            },
            {
                name: 'p1_powers',
                selector: (row) => row.p1_powers,
                sortable: true,
            },
            {
                name: 'p2_powers',
                selector: (row) => row.p2_powers,
                sortable: true,
            },
            {
                name: 'close_at',
                selector: (row) => row.close_at,
                sortable: true,
            },
            {
                name: 'release_at',
                selector: (row) => row.release_at,
                sortable: true,
            },
            {
                name: 'result',
                selector: (row) => (row.result == 1) ? "Player 1 Win" : ((row.result == 3) ? "Player 2 Win" : "Tie"),
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        hasDelete={true}
                        row={row}
                        thunkFunc={deleteWebMatchPredictionApi}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchWebMatchPredictionApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default WebMatchPrediction;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
